import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Tab } from 'app/shared/models/tab.model';

@Component({
    selector: 'sc-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss']
})

export class TabsComponent {

    @Input() tabs: Array<Tab>;
    @Output() onTabSelect: EventEmitter<Tab>;

    constructor() {
        this.onTabSelect = new EventEmitter<Tab>();
    }

    selectTab(index: number) {

        // Unselect previous selected tab
        this.tabs.forEach(tab => tab.isActive = false);
        // Set current tab as active
        this.tabs[index].isActive = true;
        
        this.onTabSelect.emit(this.tabs[index]);
    }
}